import styled from "styled-components";
import { Field } from "redux-form/immutable";
import { injectIntl, type WrappedComponentProps } from "react-intl";

import { creatable } from "../../up-styled-creatable";
import { selectBox } from "../../select-box";
import UpRegex from "../../up-regex";
import FormValueSelector from "../../up-form-value-selector";
import messages from "../messages";
import type { ResettableConditionFilterProps } from "../utils";

const Filter = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  @media only screen and (max-width: 800px) {
    flex-direction: column;
    align-items: stretch;
  }
  @media only screen and (max-width: 550px) {
    flex-direction: column;
    align-items: stretch;
    width: auto;
  }
`;

const Row = styled.div`
  margin-bottom: 0px;
  display: flex;
  flex: 1 1 auto;
  @media only screen and (max-width: 800px) {
    margin-bottom: 10px;
  }
`;

type CustomerGroupProps = ResettableConditionFilterProps &
  WrappedComponentProps;

const CustomerGroup = (props: CustomerGroupProps) => (
  <Filter>
    <Row>
      <Field
        name={`${props.member}.filter.operator`}
        component={selectBox}
        customProps={{
          options: [
            {
              value: "contains",
              label: props.intl.formatMessage(messages.contains),
            },
            {
              value: "contains-not",
              label: props.intl.formatMessage(messages.containsNot),
            },
            {
              value: "regex",
              label: props.intl.formatMessage(messages.matchesRegex),
            },
          ],
          minWidth: "250px",
          margin: "0 10px 0 0",
          onChange: () => props.resetOnChange()
        }}
      />
    </Row>
    <FormValueSelector
      fieldName={`conditions[${props.member
        .split("[")[1]
        .charAt(0)}]filter.operator`}
    >
      {(operator) =>
        operator === "regex" ? (
          <UpRegex
            name={`${props.member}.filter.attribute[0].value`}
            margin="0 10px 0 0"
            width="100%"
            fieldValidation={false}
          />
        ) : (
          <Field
            name={`${props.member}.filter.attribute`}
            component={creatable}
          />
        )
      }
    </FormValueSelector>
  </Filter>
);

export default injectIntl(CustomerGroup);
